import React from 'react'
import './styles/notification-ecomm-options.scss'
import { Well } from '@pushly/aqe/lib/components'
import { Tooltip, Select, Skeleton } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { getClassNames } from '../../../_utils/classnames'
import { titleCase } from '../../../_utils/utils'
import { CatalogItemPickStrategy } from '@pushly/models/lib/enums/catalogs'

interface INotificationCatalogItemOptionsProps {
    className?: string
    options: CatalogItemPickStrategy[]
    selectedStrategy?: CatalogItemPickStrategy
    onChange: (strategy: CatalogItemPickStrategy) => void
    loading?: boolean
    disabled?: boolean
}

const NotificationCatalogItemOptions = (props: INotificationCatalogItemOptionsProps) => {
    const { loading, disabled, options, selectedStrategy, onChange } = props

    if (!options || options.length === 0) {
        return null
    }

    const safeValue = options.includes(selectedStrategy as any) ? selectedStrategy : undefined

    return (
        <Well
            className={getClassNames('notification-ecomm-options-wrapper', {})}
            title={
                <>
                    <span>Item Selection</span>
                    <Tooltip
                        title={
                            <span>
                                Determines how the item that will be included within the notification will be chosen.
                            </span>
                        }
                    >
                        <QuestionCircleOutlined className="info-icon" />
                    </Tooltip>
                </>
            }
            mode="ghost"
            hideFooter={true}
        >
            <Skeleton loading={loading} active={true} avatar={false} title={false}>
                <Select
                    className="ecomm-item-pick-strategy-select"
                    popupClassName="ecomm-item-pick-strategy-dropdown"
                    placeholder="Select a strategy"
                    value={safeValue}
                    onChange={(strategy) => onChange(strategy as CatalogItemPickStrategy)}
                    disabled={disabled}
                >
                    {options.map((option) => (
                        <Select.Option key={option} value={option}>
                            {option === CatalogItemPickStrategy.PREVIOUSLY_SELECTED
                                ? 'Previously Chosen Item'
                                : titleCase(option)}
                        </Select.Option>
                    ))}
                </Select>
            </Skeleton>
        </Well>
    )
}

export default NotificationCatalogItemOptions
